<template>
  <div class="list">
    <el-form :model="dioForm" label-width="120px">
      <el-form-item
        v-for="item in baseArray"
        :key="item.key"
        :label="$t(item.text)"
      >
        <template
          v-if="
            item.key === 'type' ||
              item.key === 'config_status' ||
              item.key === 'status'
          "
        >
          <span>{{ textChange(item.key, item.content) }}</span>
        </template>
        <template v-else-if="item.key === 'description' && isMode">
          <el-input
            type="textarea"
            v-model="areaValue"
            maxlength="250"
            :autosize="{ minRows: 2, maxRows: 4 }"
            style="width: 300px"
            show-word-limit
          ></el-input>
        </template>
        <template v-else-if="item.key === 'nickname' && isMode">
          <el-input
            type="text"
            v-model="nickname"
            maxlength="30"
            style="width: 300px"
          ></el-input>
        </template>

        <!-- 绑定的设备 -->
        <!-- <template v-else-if="item.key === 'sensor'">
            <span v-if="item.content">
                <i :class="sensorTypeConvert(item.content.deviceType).icon" :title="$t(sensorTypeConvert(item.content.deviceType).title)" class="cursor-pointer"></i>
                {{ item.content.deviceCode }}
            </span>
            <el-button v-if="isMode" type="primary" @click="selectDevice(item.content)">{{ $t('绑定') }}</el-button>
            <el-button v-if="isMode && item.content" type="primary" @click="unbindDevice(item.content)">{{ $t('解绑') }}</el-button>
        </template> -->
        <span v-else>
          {{ item.content }}
        </span>
      </el-form-item>
      <el-form-item v-if="isMode">
        <el-button type="primary" @click="saveDecFn">
          <i class="el-icon-folder-checked button-icon "></i>
          {{ $t('public.save') }}
        </el-button>
        <el-button type="primary" @click="goBack"
          ><i class="el-icon-refresh-left button-icon"></i
          >{{ $t('integration.back') }}
        </el-button>
      </el-form-item>
      <el-form-item v-if="!isMode">
        <el-button type="primary" @click="goBack"
          ><i class="el-icon-edit button-icon"></i>{{ $t('public.edit') }}
        </el-button>
      </el-form-item>
      <!-- <slot></slot> -->
    </el-form>
    <SelectDevice
      v-bind="selectDevAttrs"
      :show.sync="selectDevAttrs.show"
      @getList="getList"
    ></SelectDevice>
  </div>
</template>

<script>
import { sBaseType } from '@/pages/equipment/base/config/search'
import { equiStatus } from '@/utils/convert'
import searchSelectFormat from '@/utils/searchSelectFormat'
import SelectDevice from '@/pages/equipment/base/components/selectDevice/SelectDevice.vue'
import { unbindSensor } from '@/api/modules/base'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  props: ['baseMsg', 'isMode', 'getListFn', 'detailObj', 'getList'],
  components: {
    SelectDevice
  },
  data () {
    return {
      dioForm: {},
      baseArray: [],
      /** 底座类型 */
      tagIdIconArray: sBaseType.selectParam,
      /** 配置状态 */

      /** 状态 */
      statusIcon: searchSelectFormat(equiStatus),
      // 详情

      nickname: '',
      areaValue: '',
      selectDevAttrs: {
        show: false,
        sceneId: 0,
        baseId: undefined,
        current: 0,
        carrierName: ''
      }
    }
  },
  computed: {
    sensorTypeConvert: () => sensorTypeConvert
  },
  created () {
    this.baseArray = [...this.baseMsg]
  },
  methods: {
    textChange (key, value) {
      if (key === 'type') {
        return this.TOODChange(value, this.tagIdIconArray)
      } else {
        return this.TOODChange(value, this.statusIcon)
      }
    },
    TOODChange (value, array) {
      var param = ''
      for (const item of array) {
        if (String(item.value) === String(value)) {
          param = item.label
          break
        }
      }
      return param
    },
    goBack () {
      this.baseArray.forEach(item => {
        if (item.key === 'nickname') {
          this.nickname = item.content
        }
        if (item.key === 'description') {
          this.areaValue = item.content
        }
      })
      this.$emit('update:isMode', !this.isMode)
    },
    saveDecFn () {
      this.$emit('saveDecFn', {
        nickname: this.nickname,
        areaValue: this.areaValue
      })
      //   sensorUpdateSensor({
      //     id: this.detailObj.id,
      //     description: this.areaValue
      //   })
    },
    selectDevice (info = {}) {
      this.selectDevAttrs.baseId = undefined
      console.log(this.detailObj)
      this.$nextTick(() => {
        this.selectDevAttrs = {
          show: true,
          baseId: this.detailObj.id,
          current: info.id,
          sceneId: this.detailObj.scene_id,
          carrierName: this.detailObj.carrierName
        }
      })
    },
    unbindDevice (device) {
      this.$confirm('你确定要解绑该设备吗?').then(() => {
        unbindSensor(device.plinthId).then(() => {
          this.$message({
            message: '解绑成功',
            type: 'success'
          })
          this.getListFn()
          this.getList()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  flex: 1;
}

::v-deep .button-icon {
  margin: 0;
  color: white;
  font-size: 14px;
  font-weight: 100;
  margin-right: 5px;
}
</style>
